import { FieldErrorModelBase } from "./FieldErrorModel.base"


/* A graphql query fragment builders for FieldErrorModel */
export { selectFromFieldError, fieldErrorModelPrimitives, FieldErrorModelSelector } from "./FieldErrorModel.base"

/**
 * FieldErrorModel
 */
export const FieldErrorModel = FieldErrorModelBase
  .actions(self => ({
    // This is an auto-generated example action.
    log() {
      console.log(JSON.stringify(self))
    }
  }))
